import React from 'react';
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text3 } from "../../../styles";
import { Descriptions, Badge } from "antd";
import moment from 'moment';
import { MERCHANT_REPORT_STATUS_TYPES } from '../../../constants';


const ReportDetailsDrawer = (props) => {
    const { report } = props;


    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Report Details</Text1>
            </div>
        )
    };


    const renderBasicDetails = () => {  
        return (
        <> 
            <Descriptions className="mb-4 mt-2" title="" column={1} size="small" bordered>
                <Descriptions.Item label="Name">{report.name}</Descriptions.Item>
                <Descriptions.Item label="Type">{report.report_type_label}</Descriptions.Item>
                <Descriptions.Item label="Duration">{moment(report.duration_start_date).format("LL")} to {moment(report.duration_end_date).format("LL")}</Descriptions.Item>
                <Descriptions.Item label="Status">
                    {report.status &&<Badge color={MERCHANT_REPORT_STATUS_TYPES[report.status].color} text={MERCHANT_REPORT_STATUS_TYPES[report.status].label} />}
                 </Descriptions.Item>
            </Descriptions>
        </>
        )
    };

    const renderAdditionalDetails = () => {  
        return (
        <>  <div>
            <Text3 strong>Selected Filters</Text3>
            </div>
            <Descriptions className="mb-4 mt-2" title="" column={1} size="small" bordered>
                {Object.entries(report.filter_args).map(([key, value]) => <Descriptions.Item label={key}>{value}</Descriptions.Item>)}
            </Descriptions>
        </>
        )
    };
  


    return (
        <EaseDrawer
            className="report-details-wrapper"
            title={false}
            width={"32%"}
            visible={props.visible}
            onClose={props.toggleDetailsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderBasicDetails()}
                {report.filter_args && Object.keys(report.filter_args).length > 0 && renderAdditionalDetails()}
            </div>
        </EaseDrawer>
    )
};

export { ReportDetailsDrawer };